export default {
    url: 'delta-3-ultra-portable-power-station',
    include: ['us'],
};
